import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import signUpSideImageWeb from 'Assets/img/svg/authentication/signup/signUpSideImageWeb.svg';
import { CommonButtonTypes } from 'Common/Types/Types';
export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexWrap: 'wrap',
			fontFamily: 'Poppins',
		},
		margin: {
			margin: 0,
		},
		display: {
			position: 'absolute',
			right: 0,
			fontFamily: 'Poppins',
		},
		background: {
			borderRadius: '3rem',
			marginTop: '-5rem',
			zIndex: 999,
			[theme.breakpoints.down('xs')]: {
				marginTop: '9.9rem',
				// marginTop: '-3rem',
				// zIndex: -1,
			},
		},
		side: {
			background: `url(${signUpSideImageWeb})`,
			// height: '100vh',
			width: '40%',
			fontFamily: 'Poppins',
		},
		mobileBackground: {
			height: '147.86px',
			background: 'rgb(241, 246, 250)',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'flex-end',
			marginLeft: '20%',
			textAlign: 'center',
			padding: '.5rem .4rem',
			[theme.breakpoints.down('xs')]: {
				background: '#7FD6DD',
				height: '247.86px',
				display: 'flex',
				width: '-webkit-fill-available',
				position: 'fixed',
				margin: 0,
				zIndex: 999,
				alignItems: 'center',
				justifyContent: 'center',
				textAlign: 'center',
				padding: '.5rem .4rem',
				cursor: 'pointer',
			},
		},
		membershipName: {
			background: '#7FD6DD',
			borderRadius: '5rem',
			padding: '1rem 2rem',
			[theme.breakpoints.down('xs')]: {
				background: '#FEDA37',
				position: 'absolute',
				zIndex: 9999,
			},
		},
		text: { fontFamily: 'Poppins', fontSize: '18px' },
		subText: { fontFamily: 'Poppins', fontSize: '12px' },
		links: {
			color: '#78393D',
			textDecoration: 'none',
			width: '100%',
			'&:hover': {
				color: 'rgb(80 35 38)',
			},
			[theme.breakpoints.down('xs')]: {
				cursor: 'pointer',
			},
		},
		removeKid: {
			marginTop: '-2rem',
			fontFamily: 'Poppins',
			textDecoration: 'underline',
			fontSize: '17px',
			textAlign: 'center',
			cursor: 'pointer',
			padding: '.1rem 0',
			color: 'black',
			'&:hover': { color: 'orange' },
		},
		goBack: {
			background: '#7FD6DD',
			borderRadius: '5rem',
			fontFamily: 'Poppins',
			fontSize: '12px',
			textAlign: 'center',
			cursor: 'pointer',
			padding: '1rem 2rem ',
			// color: '#cacaca',
			'&:hover': { color: 'orange' },
			[theme.breakpoints.down('xs')]: {
				background: '#FEDA37',
				position: 'absolute',
				zIndex: 9999,
				marginTop: '-10rem',
				// color: 'black',
				fontSize: '14px',
			},
		},
		addChildModal: {
			margin: '4rem auto',
			background: 'white',
			width: '50%',
			borderRadius: '5px',
			padding: '1rem',
			[theme.breakpoints.down('xs')]: {
				width: '90%',
			},
		},
		loading: {
			display: 'flex',
			justifyContent: 'center',
			flexDirection: 'column',
			alignItems: 'center',
			marginTop: '3rem',
		},
		listItems: {
			listStyleType: 'none',
			margin: 0,
			padding: 0,
			fontFamily: 'Poppins',
			[theme.breakpoints.down('xs')]: {
				// background: '#F1F6FA',
				borderRadius: '2rem',
				padding: '2rem !important',
				fontSize: '16px',
				marginTop: '4rem',
			},
		},
		childBackground: {
			fontFamily: 'Poppins',
			border: '1px solid #e4e4e4',
			padding: '0 2rem',
			boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px',
			margin: '1rem 0',
			borderRadius: '2rem',
			background: 'white',
			[theme.breakpoints.down('xs')]: {
				background: 'white',
				borderRadius: '2rem',
				marginTop: '1.2rem',
				padding: '2rem !important',
				fontSize: '16px',
			},
		},
		positionLogo: {
			position: 'absolute',
			width: '300px',
			height: '200px',
			zIndex: 15,
			top: '50%',
			left: '50%',
			margin: '-100px 0 0 -150px',
			objectFit: 'contain',
			fontFamily: 'Poppins',
		},
		search: {
			position: 'relative',
			// borderRadius: theme.shape.borderRadius,
			// backgroundColor: fade(theme.palette.common.white, 0.15),
			// '&:hover': {
			// 	backgroundColor: fade(theme.palette.common.white, 0.25),
			// },
			margin: '1rem 1rem 0',
			width: '30%',
			background: ' #f8f9fa !important',
			borderRadius: '30px',
			[theme.breakpoints.down('sm')]: {
				marginLeft: theme.spacing(1),
				width: '90% !important',
				float: 'right',
				margin: '0 1rem',
				marginTop: '1rem !important',
			},
		},
		searchIcon: {
			padding: theme.spacing(0, 2),
			height: '100%',
			position: 'absolute',
			pointerEvents: 'none',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		inputRoot: {
			color: 'inherit',
		},
		inputInput: {
			padding: theme.spacing(1, 1, 1, 0),
			paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
			transition: theme.transitions.create('width'),
			width: '30%',
			[theme.breakpoints.up('sm')]: {
				width: '8ch',
				'&:focus': {
					width: '20ch',
				},
			},
		},
		listItem: {
			listStyleType: 'none',
			display: 'flex',
			flexDirection: 'column',
			width: '100%',
			height: '100vh',
		},
		// links: {
		// 	color: '#78393D',
		// 	textDecoration: 'none',
		// 	width: '100%',
		// 	'&:hover': {
		// 		color: 'rgb(80 35 38)',
		// 	},
		// },
		pagination: {
			position: 'fixed',
			padding: '.2rem !important',
			display: 'flex',
			justifyContent: 'center',
			bottom: 0,
			width: '100%',
			background: '#f8f9fa !important ',
		},
		image: {
			width: '250px',
			objectFit: 'contain',
			margin: '0 3rem',
			padding: '1rem 0',
		},
		// loading: {
		// 	display: 'flex',
		// 	justifyContent: 'center',
		// 	flexDirection: 'column',
		// 	alignItems: 'center',
		// 	marginTop: '3rem',
		// },
		table: {
			width: '99%',
			marginLeft: 'auto',
			marginRight: 'auto',
			// border: '1px solid black',
		},
		title: {
			padding: '0.2rem',
			fontSize: '1rem',
			// margin: '1rem',
			fontFamily: 'Poppins',
			marginBottom: '10px',
			fontWeight: 'bold',
		},
		subTitle: {
			fontSize: '18px',
			fontFamily: 'Poppins',
			marginLeft: '1rem',
			fontWeight: 'normal',
		},
		flex: {
			display: ' flex',
			flexDirection: 'row',
			// flexBasis: 1,
			rowGap: '1.6rem',
		},
		clickButton: {
			border: 'none',
		},
		homeDisplay: {
			display: 'flex',
			flexDirection: 'row',
			rowGap: '1rem',

			// [theme.breakpoints.up('sm')]: {
			// 	display: 'flex',
			// 	flexDirection: 'column',
			// 	rowGap: '1rem',
			// 	alignItems: 'center',
			// 	justifyContent: 'center',
			// },
		},
	}),
);
